<button type="button" class="buttonLogin" (click)="login()" *ngIf="!(af.auth | async)?.uid">Guest Login</button>
